<div class="modal-body">
  <div class='col'>
    <p>
      <ngb-progressbar type="info"
        [max]="maxValue"
        [value]="currentValue"
        [striped]="true"
        [animated]="true">
        {{ currentValue / maxValue | percent }}
      </ngb-progressbar>
    </p>
  </div>
</div>
